<div class="host-edit-guest">
  <div class="form-container" [formGroup]="form">
    <div class="left">
      <div class="form-control">
        <span class="label">{{ "modal.add_guest.form.name" | translate }}</span>
        <div class="control">
          <input
            type="text"
            nz-input
            [attr.placeholder]="'placeholder.add_guest.name' | translate"
            formControlName="name"
          />
        </div>
      </div>
      <div class="form-control">
        <span class="label">{{ "modal.add_guest.form.sex" | translate }}</span>
        <div class="control">
          <nz-radio-group formControlName="gender">
            <label nz-radio [nzValue]="1">{{ "word.male" | translate }}</label>
            <label nz-radio [nzValue]="2">{{ "word.female" | translate }}</label>
          </nz-radio-group>
        </div>
      </div>
      <div class="form-control">
        <span class="label">{{ "modal.add_guest.form.mobile" | translate }}</span>
        <div class="control">
          <input
            type="phone"
            nz-input
            [attr.placeholder]="'placeholder.add_guest.mobile' | translate"
            formControlName="phone"
          />
        </div>
      </div>
      <div class="form-control">
        <span class="label">{{ "modal.add_guest.form.email" | translate }}</span>
        <div class="control">
          <input
            type="text"
            nz-input
            [attr.placeholder]="'placeholder.add_guest.email' | translate"
            formControlName="email"
          />
        </div>
      </div>
      <div class="form-control">
        <span class="label">{{ "modal.add_guest.form.id_type" | translate }}</span>
        <div class="control">
          <nz-select 
            [nzPlaceHolder]="'placeholder.add_guest.id_type' | translate" 
            [nzDropdownMatchSelectWidth]="false"
            formControlName="id_type">
            <nz-option
              *ngFor="let option of idTypeOptions"
              [nzValue]="option.value"
              [nzLabel]="option.key | translate"
            ></nz-option>
          </nz-select>
        </div>
      </div>
      <div class="form-control">
        <span class="label">{{ "modal.add_guest.form.id" | translate }}</span>
        <div class="control">
          <input
            type="text"
            nz-input
            [attr.placeholder]="'placeholder.add_guest.id' | translate"
            formControlName="id_number"
          />
        </div>
      </div>
      <div class="form-control">
        <span class="label">{{ "modal.add_guest.form.birthday" | translate }}</span>
        <div class="control">
          <nz-date-picker
            [nzPlaceHolder]="'placeholder.add_guest.birthday' | translate"
            formControlName="birthday"
          ></nz-date-picker>
        </div>
      </div>
      <div class="form-control">
        <span class="label">{{ "modal.add_guest.form.country" | translate }}</span>
        <div class="control">
          <nz-select 
            [nzPlaceHolder]="'placeholder.add_guest.country' | translate" 
            formControlName="country">
            <nz-option
              *ngFor="let option of countryOptions"
              [nzValue]="option.alpha2"
              [nzLabel]="option.name"
            ></nz-option>
          </nz-select>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="form-control"  style="margin-bottom: 20px">
        <span class="label">{{ "modal.add_guest.form.note" | translate }}</span>
        <div class="control">
          <textarea
            rows="4"
            nz-input
            formControlName="comment"
            [attr.placeholder]="'placeholder.add_guest.note' | translate"
          ></textarea>
        </div>
      </div>
      <div class="form-control">
        <span class="label">{{ "modal.add_guest.form.tag" | translate }}</span>
        <div class="control">
          <host-guest-tag formControlName="client_tags"></host-guest-tag>
        </div>
      </div>
      <div class="form-control">
        <span class="label">{{ "modal.add_guest.form.certificate" | translate }}</span>
        <div class="control">
          <host-base-image-upload
            formControlName="client_credential"
            showBigImg="true"
          ></host-base-image-upload>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <button nz-button (click)="onClickCancel()">{{ "word.cancel" | translate }}</button>
    <button nz-button nzType="primary" (click)="onClickConfirm()">{{ "word.save" | translate }}</button>
  </div>
</div>
